import { Box, Typography, alpha } from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

type InfoLineProps = {
    text: string;
};

export function InfoLine({ text }: InfoLineProps) {
    return (
        <Box
            display="flex"
            alignItems="center"
            gap={1}
            p={1}
            borderRadius={1}
            sx={(theme) => ({
                backgroundColor: alpha(
                    theme.palette.info.main,
                    theme.palette.mode === "dark" ? 0.12 : 0.08
                ),
                color: theme.palette.text.primary,
            })}
        >
            <InfoOutlineIcon color="info" fontSize="small" />
            <Typography variant="body2">{text}</Typography>
        </Box>
    );
}